import { render, staticRenderFns } from "./ShopStartPage.vue?vue&type=template&id=c3aea432&"
import script from "./ShopStartPage.vue?vue&type=script&lang=js&"
export * from "./ShopStartPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopStartPage.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports